var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSearch = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/lined/search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4963879,28.0821744 L39.3737735,37.9595599 C39.7642978,38.3500842 39.7642978,38.9832492 39.3737735,39.3737735 C38.9832492,39.7642978 38.3500842,39.7642978 37.9595599,39.3737735 L28.0821744,29.4963879 C25.991492,31.2661765 23.2870366,32.3333333 20.3333333,32.3333333 C13.7059163,32.3333334 8.3333333,26.9607503 8.3333333,20.3333333 C8.3333333,13.7059163 13.7059163,8.3333333 20.3333333,8.3333333 C26.9607503,8.3333333 32.3333334,13.7059163 32.3333333,20.3333333 C32.3333333,23.2870366 31.2661765,25.991492 29.4963879,28.0821744 L29.4963879,28.0821744 Z M10.3333333,20.3333333 C10.3333333,25.8561808 14.8104858,30.3333333 20.3333333,30.3333333 C25.8561808,30.3333333 30.3333333,25.8561808 30.3333333,20.3333333 C30.3333333,14.8104858 25.8561808,10.3333333 20.3333333,10.3333333 C14.8104858,10.3333333 10.3333333,14.8104858 10.3333333,20.3333333 Z",
    id: "Shape",
    fill: "#0A1428",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.4142dcf6.svg";
export { ForwardRef as ReactComponent };